export function parseNullableOrEmpty(data: string | null) {
  if (!data || !data.length) return null;
  return data;
}
